import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9952194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999","font-size":"12px","margin-bottom":"15px"} }, " 建议尺寸：750x250 像素，尺寸不匹配时，图片将被压缩或拉伸以铺满画面 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_layout1, {
      title: "背景图片",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_ui_upload_image_list, {
          modelValue: _ctx.modelValue.backgroundImage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.backgroundImage) = $event)),
          showClose: false,
          tips: "更换图片"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}